import { alpha, createTheme, getContrastRatio } from "@mui/material/styles";
import { Transition } from "notistack";
// import { Plus_Jakarta_Sans } from "next/font/google";

// export const plus = Plus_Jakarta_Sans({
//   weight: ["300", "400", "500", "600", "700"],
//   subsets: ["latin"],
//   display: "swap",
//   fallback: ["Helvetica", "Arial", "sans-serif"],
// });

const baselightTheme = createTheme({
  direction: "ltr",
  palette: {
    primary: {
      main: "#9E6747",
      light: "#ECF2FF",
      dark: "#1a6dcc",
    },
    secondary: {
      main: "#49BEFF",
      light: "#E8F7FF",
      dark: "#23afdb",
    },
    success: {
      main: "#13DEB9",
      light: "#E6FFFA",
      dark: "#02b3a9",
      contrastText: "#ffffff",
    },
    info: {
      main: "#539BFF",
      light: "#EBF3FE",
      dark: "#1682d4",
      contrastText: "#ffffff",
    },
    auth: {
      main: "#f9f4eb",
      light: "#EBF3FE",
      dark: "#1682d4",
      contrastText: "#ffffff",
    },
    error: {
      main: "#FA896B",
      light: "#FDEDE8",
      dark: "#f3704d",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#FFAE1F",
      light: "#FEF5E5",
      dark: "#ae8e59",
      contrastText: "#ffffff",
    },

    bluebutton: {
      main: "#9e6747",
      light: alpha("#2189ff", 0.5),
      dark: alpha("#000000", 0.9),
      contrastText: getContrastRatio(alpha("#000000", 0.9), "#fff") > 4.5 ? "#fff" : "#111",
    },
    blackbutton: {
      main: alpha("#000000", 0.9),
      light: alpha("#000000", 0.5),
      dark: "#2189ff",
      contrastText: getContrastRatio(alpha("#000000", 0.9), "#fff") > 4.5 ? "#fff" : "#111",
    },
    blackiconbutton: {
      main: alpha("#000000", 0.9),
      light: "#2189ff",
      dark: "#2189ff",
      contrastText: getContrastRatio(alpha("#000000", 0.9), "#fff") > 4.5 ? "#fff" : "#111",
    },
    grey: {
      100: "#F2F6FA",
      200: "#EAEFF4",
      300: "#DFE5EF",
      400: "#7C8FAC",
      500: "#5A6A85",
      600: "#2A3547",
    },
    text: {
      primary: "#1E1E1E",
      secondary: "#1E1E1E",
      black:"000000",
    },
    action: {
      disabledBackground: "rgba(73,82,88,0.12)",
      hoverOpacity: 0.02,
      hover: "#f6f9fc",
    },
    divider: "#e5eaef",
  },
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
    h1: {
      fontWeight: 600,
      // fontSize: "2.5rem",
      // lineHeight: "2.75rem",
      // fontFamily: plus.style.fontFamily,
    },
    h2: {
      fontWeight: 600,
      // fontSize: "1.875rem",
      // lineHeight: "2.25rem",
      // fontFamily: plus.style.fontFamily,
    },
    h3: {
      fontWeight: 600,
      // fontSize: "1.5rem",
      // lineHeight: "1.75rem",
      // fontFamily: plus.style.fontFamily,
    },
    h4: {
      fontFamily: "'Playfair Display', serif", // Ensure this matches the imported font name
      fontWeight: 600,
      fontSize: "3.125rem",
      lineHeight: 1.2,
    },
    // h4: {
    //   fontWeight: 600,
    //   // fontSize: "1.3125rem",
    //   // lineHeight: "1.6rem",
    // },
    h5: {
      fontWeight: 600,
      // fontSize: "1.125rem",
      // lineHeight: "1.6rem",
    },
    h6: {
      fontWeight: 600,fontFamily: "'Playfair Display', serif",
      // fontSize: "1rem",
      // lineHeight: "1.2rem",
    },
    button: {
      textTransform: "capitalize",
      fontWeight: 500,
    },
    body1: {
      // fontSize: "0.875rem",
      fontWeight: 400,
      // lineHeight: "1.334rem",
    },
    body2: {
      // fontSize: "0.75rem",
      letterSpacing: "0rem",
      fontWeight: 400,
      // lineHeight: "1rem",
    },
    subtitle1: {
      // fontSize: "0.875rem",
      fontWeight: 400,
    },
    subtitle2: {
      // fontSize: "0.875rem",
      fontWeight: 400,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ".MuiPaper-elevation9, .MuiPopover-root .MuiPaper-elevation": {
          boxShadow:
            "rgb(145 158 171 / 30%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px !important",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "7px",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
          padding: "10px",
          transition: "background-color 0.5s ease, color 0.5s ease",
          "&:hover": {
            backgroundColor: "#000", // Sets hover background color to black
            color: "#fff", // Optional: Ensures text color contrasts well with black


          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: 'collapse', // Ensures borders between cells collapse into one line
          width: '100%', // Makes the table take up the full width
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          border: "1px solid #ababab",
          // borderBottom: "0",
          textAlign: 'center',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '& th': {
            backgroundColor: '#9E6747',
            color: 'white', // Text color for header cells
            fontFamily: "'Nunito Sans', sans-serif",
            fontSize: "18px"
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#F9F9F9",
          borderRadius: "0",
          color: "gray",
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "1px solid #9c6b53",

          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          color: "#7C8FAC", // Default label color
          "&.Mui-focused": {
            color: "#9c6b53", // Label color when focused
            fontSize: "12px",

          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: "inherit", // Inherit the default text color
          // bottom: -2,
          textDecoration: "none", // No underline by default
          position: "relative", // Required for the animated underline


          "&:hover": {
            color: "#9c6b53", // Brown color on hover
            textDecoration: "none", // Keeps the text clean without browser default underline
          },
          "&:after": {
            content: '""',
            position: "absolute",
            left: 0,
            bottom: -2, // Adjust the underline position
            width: 0,
            height: "2px",
            backgroundColor: "#9c6b53", // Brown underline color
            transition: "width 0.3s ease", // Smooth animation for the underline
          },
          "&:hover:after": {
            width: "100%", // Full width underline on hover
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent",  // White background color for the Select component
          color: "#ffffff",            // Black text color for the Select component
          border: "none", // Gray border color for the Select box
          borderRadius: "0px",         // Rounded corners
          padding: "6px 12px",         // Padding for proper sizing
          fontSize: "0.875rem",
          height: 20, // Reduce height of individual MenuItems
          fontSize: '0.875rem',


          // '&.Mui-focused': {
          //   border: "none",  
          //   backgroundColor: "red", // Blue border color on focus
          //   // boxShadow: "0 0 0 2px rgba(52, 152, 219, 0.2)", // Box-shadow with light blue on focus
          // },

          // '&:hover': {
          //   backgroundColor: "#f4f4f4",  // Light gray background on hover
          //   borderColor: "#3498db",      // Blue border color on hover
          // },
        },
        icon: {
          color: "#ffffff",  // Black color for the dropdown arrow
        },

      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          height: 20,               // Reduce height of individual MenuItems
          fontSize: "0.875rem",     // Font size for menu items
          color: "#000000",         // Black color for text of menu items

          // Selected state comes first to ensure it has higher precedence
          '&.Mui-selected': {
            backgroundColor: "#ffffff", // Brownish background when selected
            color: "#000000",           // White text color when selected
          },

          '&:hover': {
            backgroundColor: "#9e6747", // Brownish background on hover
            color: "#ffffff",           // White text color on hover
          },

          // '&.Mui-focused': {
          //   backgroundColor: "#9e6747", // Brownish background when focused
          //   color: "red",           // White text color when focused
          // },

          '&.Mui-active': {
            backgroundColor: "#9e6747", // Brownish background when active (selected)
            color: "#000000",           // White text color when active
          },
        },
      },
    },

  },
});

export { baselightTheme };
